import {
	INSTRUMENT_CHECK_REQUEST,
	INSTRUMENT_CHECK_SUCCESS,
	INSTRUMENT_CHECK_ERROR,
	INSTRUMENT_CHECK_RESET,
	UPDATE_SELECTED_PAYMENT_OPTION,
	UPDATE_EMI_CARD_PAYMENT_OPTION
} from 'actions/PaymentActions/PaymentActions';
import { UPDATE_EMI_BANK } from 'actions/PaymentActions/emiStateActions';
import { INIT, LOADING, SUCCESS, ERROR } from 'utils/asyncStatusHelper';
import { PAYMENT_INSTRUMENT } from 'pages/PaymentsPage/PaymentOptions/constants';

export const INITIAL_STATE = {};

// TODO: Discuss with backed if caching the instrument call per token is a good
// idea. If not, remove the map structure, and flatten it into one.
export default function instrumentCheck(state = INITIAL_STATE, action = {}) {
	switch (action.type) {
		// FIXME: These two actions get triggerred for _every_ payment option
		// change call. This can be avoided.
		// TODO: This might break if UPDATE_EMI_BANK doesn't get triggerred when
		// the user clicks on the "choose another option" button. It gets
		// triggerred currently because the component, on mount, triggeres some
		// specific actions. This might get changed at some point.
		//
		// Note: Take care with this style because these actions get triggered if
		// the user doesn't stop propagating the event in the change action.
		case UPDATE_EMI_CARD_PAYMENT_OPTION:
		case UPDATE_EMI_BANK:
			return Object.assign({}, state, {
				[PAYMENT_INSTRUMENT.EMI_CREDIT_CARD]: { asyncStatus: INIT, requestData: {} }
			});
		case UPDATE_SELECTED_PAYMENT_OPTION:
			return Object.assign({}, state, {
				[PAYMENT_INSTRUMENT.CREDIT_CARD]: { asyncStatus: INIT, requestData: {} }
			});
		case INSTRUMENT_CHECK_REQUEST:
			return Object.assign({}, state, {
				[action.cardId]: { requestData: {}, asyncStatus: LOADING }
			});
		case INSTRUMENT_CHECK_ERROR:
			return Object.assign({}, state, {
				[action.cardId]: { error: action.error, requestData: action.requestData, asyncStatus: ERROR }
			});
		case INSTRUMENT_CHECK_SUCCESS:
			return Object.assign({}, state, {
				[action.cardId]: { ...action.data, requestData: action.requestData, asyncStatus: SUCCESS }
			});
		case INSTRUMENT_CHECK_RESET:
			return Object.assign({}, state, {
				[action.cardId]: {}
			});
		default:
			return state;
	}
}
